module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAAYCAYAAABgBArrAAAACXBIWXMAAAsSAAALEgHS3X78AAAA+klEQVRo3u2Y4Q2CMBCFH4YBGIURykhuwAiO4AbqBDACI7CBbKA/LAkhCtyjbSJ5X9Kf3Ou9lmt7GYACQAlgANCBY4zB0HltKy6QnluYxzSvlpngyw+WaQzrYA1i9eofcVxIb3KEx7qyw049647vkIAYxlZIy5n5TWNzgpCxMlZEMXbtVH4G1ms2aJbasQchxq0gS5xDpVuBaqyQsX9SY2vj0/VbbauNc7gEeNamwJJXP280sM0MNkaIJozbadjWJoxlNLl3lzlV29kK3fFps1kYxtUluHq9fqexS3HYvB4qhkIIIcTBKMnr1k0vr2UK9rtM3m3atVaD+zdw85OP7MkBKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1